import database from '../components/firebaseInit'

// A reference to the users collection.
const users = database.collection('users');

export default {
  methods: {
    getGrade: function () {
      const docRef = users.doc(this.uid);
      docRef.get().then((documentSnapshot) => {
        if (documentSnapshot.exists) {
          const data = documentSnapshot.data();
          let answerValues = [];
          // Loop through answers and push values to new array.
          for (const answer in data.answers) {
            if (data.answers.hasOwnProperty(answer)) {
              answerValues.push(data.answers[answer]);
            }
          }
          let sum = 0;
          // Loop through values and get the total sum.
          for (let i = 0; i < answerValues.length; i++) {
            sum += parseInt(answerValues[i]);
          }

          // Check for invalid sum first.
          if (typeof sum !== 'number' || sum < 0 || sum > 80) {
            console.log("Invalid sum");
          }

          // Relate sum to a grade.
          let grade = "";

          if (sum <= 16) {
            // Set grade to 1 when total is 16 or below.
            grade = 1;
          } else {
            // Multiply to get unrounded grade.
            grade = sum * 0.15625;
            // Round up grade to one decimal.
            grade = Math.round(grade * 10) / 10;
          }

          this.grade = grade;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/getGrade.js